document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')

  if (header.classList.contains('header-main')) {
    window.addEventListener('scroll', () => {
      window.scrollY > 150 ? header.classList.add('header-main--view') : header.classList.remove('header-main--view')
    })
  }

  // const headerVideo = document.querySelector('.banner__video video')
  // headerVideo.onloadeddata = ()=> {
  //   headerVideo.play()
  // }

})